export default "__VITE_ASSET__BTHrQ$mW__"